import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Menu from './pages/Menu';
import Login from './pages/Login';
import Index from './pages/Index';
import Modal from 'react-modal';

import "primereact/resources/themes/lara-light-indigo/theme.css";  //theme
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";                                //icons
import "primeflex/primeflex.css";

import 'primereact/resources/primereact.css';
import './assets/demo/flags/flags.css';
import './assets/demo/Demos.scss';
import './assets/layout/layout.scss';

import Perfil from './pages/Perfil';
import Curso from './pages/Historia';
import Usuario from './pages/Usuario';
import NotFoundPage from './pages/NotFoundPage';
import Historia from './pages/Historia';
import ListaHistorias from './pages/ListaHistorias';
import DetalleHistoria from './pages/DetalleHistoria';
import MainLayout from './pages/MainLayout';
//Modal.setAppElement('#root');

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Menu />} >
          <Route exact path="perfil" element={<Perfil />} />
          <Route exact path='notfound' element={<NotFoundPage />} />
          <Route exact path="usuario" element={<Usuario />} />
          <Route exact path="historia" element={<Historia />} />
        </Route>
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/index" element={<Index />} />
        <Route exact path="/listahistorias" element={<ListaHistorias />} />
        <Route exact path="/historia/:id" element={<DetalleHistoria />} />
        
        <Route element={<MainLayout />}>

        </Route>
        
      </Routes>
    </BrowserRouter>
  );
}

export default App;
